/* Package JSON Import will be here */
import React from "react";
import { Tooltip } from "antd";
/* Package JSON Import will be here */

const TooltipComp = (props: any) => {
    if (props.title) {
        return (
            <Tooltip placement={props.position !== undefined ? props.position : "topLeft"} title={props.title} color="#87d068">
                {props.children}
            </Tooltip>
        );
    }
    else {
        return (props.children);
    }
}

export default TooltipComp;